import { render, staticRenderFns } from "./smallCard.vue?vue&type=template&id=a2c4d73e&scoped=true&"
import script from "./smallCard.vue?vue&type=script&lang=js&"
export * from "./smallCard.vue?vue&type=script&lang=js&"
import style0 from "./smallCard.vue?vue&type=style&index=0&id=a2c4d73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c4d73e",
  null
  
)

export default component.exports